var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('movements-list',{attrs:{"movements":_vm.walletMovements,"totalPages":_vm.totalPages,"pageSettings":_vm.pagination},on:{"change":_vm.updatePagination}}),(_vm.loading)?_c('loading-page'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }